import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.idp-authenticators.add', {
        url: '/add',
        component: 'companyIdpAuthenticatorsAdd',
        resolve: {
        },

    });
}




// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/add/idp-authenticator-add.state.js